module.exports = __webpack_public_path__ + "static/media/electrodomesticos.c3749886.png";